import { $time, YTime } from './time';

export class YStopWatch {
    private _count: number;
    private _start?: YTime;

    constructor() {
        this._count = 0;
    }

    get value() {
        let count = this._count;
        if(this._start)
            count += $time.now().sub(this._start, $time.second);
        return count;
    }

    start() {
        if(!this._start)
            this._start = $time.now();
    }

    stop() {
        if(this._start) {
            this._count += $time.now().sub(this._start, $time.second);
            this._start = undefined;
        }
    }

    reset() {
        let count = this._count;
        this._count = 0;

        if(this._start) {
            const now = $time.now();
            count += now.sub(this._start, $time.second);
            this._start = now;
        }

        return count;
    }
}